import { useTheme } from "next-themes";
import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "light" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      richColors
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-gray-900 group-[.toaster]:text-white group-[.toaster]:border-gray-700 dark:group-[.toaster]:bg-white dark:group-[.toaster]:text-black dark:group-[.toaster]:border-gray-200 group-[.toaster]:shadow-xl group-[.toaster]:text-sm group-[.toaster]:min-w-[360px]",
          description: "group-[.toast]:text-gray-300 dark:group-[.toast]:text-gray-600 group-[.toast]:text-sm",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          error: "animate-pulse [animation-iteration-count:1]",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
